import Cookies from 'js-cookie';
const COOKIE_OPTIONS: Cookies.CookieAttributes = {
  expires: 7,
  secure: false,
  sameSite: 'strict',
};
export function getItem<T>(key: string): T | null {
  const value = Cookies.get(key);
  return value ? JSON.parse(value) : null;
}

export function setItem<T>(key: string, value: T): void {
  Cookies.set(key, JSON.stringify(value), COOKIE_OPTIONS);
}

export function removeItem(key: string): void {
  Cookies.remove(key);
}
